<template>
   <el-dialog custom-class="dialog-wrapper" :title="dialogTitle" :close-on-click-modal="false"
      :modal-append-to-body="false" v-model="dialogVisible">
      <el-form class="form-wrapper" label-width="40px" label-position="left" :model="configInfo">
         <el-form-item style="margin-bottom: 20px;" label="链接">
            <el-input v-model="configInfo.link"></el-input>
         </el-form-item>
         <el-form-item label="图片">
            <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=4" tips="支持 jpg、png"
               :urls="configInfo.image" @onUrls="imageUploaded">
            </UploadImage>
         </el-form-item>
      </el-form>
      <template #footer>
         <div class="flex-row-center">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="clickEditDone">确定</el-button>
         </div>
      </template>
   </el-dialog>
</template>

<script>
import UploadImage from "../../../../../components/UploadItems/UploadImage.vue";

export default {
   components: {
      UploadImage
   },

   props: {
      dialogTitle: '',
      dataSource: {}
   },

   data() {
      return {
         dialogVisible: false,
         configInfo: { link: '', image: '' },
      }
   },

   methods: {
      // 发送更新
      sendUpdate() {
         const resValue = {
            'PINAAN_GIFT_LINK': this.configInfo.link,
            'PINAAN_GIFT_IMAGE': this.configInfo.image,
         };
         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: JSON.stringify(resValue),
         };
         this.$http({
            url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.dialogVisible = false;
               this.$emit('refresh');
            } else {
               this.$util.errorMsg(res.message);
            }
         }).catch((error) => {
            this.$util.errorMsg('获取详情信息失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 点击编辑
      clickEdit() {
         if (!this.dataSource.resValue || this.dataSource.resValue === '{}') {
            this.configInfo = { link: '', image: '' };
         } else {
            const resValue = JSON.parse(this.dataSource.resValue);
            this.configInfo = {
               link: resValue['PINAAN_GIFT_LINK'],
               image: resValue['PINAAN_GIFT_IMAGE'],
            };
         }
         this.dialogVisible = true;
      },

      // 图片上传成功
      imageUploaded(img) {
         this.configInfo.image = img;
      },

      // 点击编辑弹框确认
      clickEditDone() {
         if (!this.configInfo.link || this.configInfo.link === '') {
            this.$message.error('请输入链接');
            return;
         }
         if (!this.configInfo.image || this.configInfo.image === '') {
            this.$message.error('请上传图片');
            return;
         }
         this.sendUpdate();
      },

   }
}
</script>

<style scoped>
.form-wrapper {
   margin-left: 0px;
}
</style>


// WEBPACK FOOTER //
// SchoolOpenGiftPack.vue?7b002760